import React, { useState } from "react";
import PropertyForm from "@/pages/PropertyForm";
import { PlusSquare, CheckCircle2, ArrowRight } from "lucide-react";

/**
 * Nuovo Annuncio dentro il VD Manager.
 * Riusa esattamente il form pubblico di pubblicazione. L'annuncio creato:
 *  - viene salvato in /api/properties (owner_id = agenzia)
 *  - appare automaticamente nel tab "Immobili" (/me/properties)
 *  - è pubblicato su VendiDirect (visibile su /annunci)
 *  - è incluso automaticamente nel feed XML per i portali esterni attivati
 */
export default function CrmNewProperty({ onGoToProperties }) {
    const [publishedId, setPublishedId] = useState(null);

    const handleSuccess = (id) => {
        setPublishedId(id);
        try { window.scrollTo({ top: 0, behavior: "smooth" }); } catch { /* noop */ }
    };

    if (publishedId) {
        return (
            <div data-testid="crm-new-property-success" className="max-w-2xl">
                <div className="border border-green-700/40 bg-green-900/10 p-8">
                    <CheckCircle2 size={32} className="text-green-400 mb-3" />
                    <span className="label-eyebrow text-gold">Annuncio pubblicato</span>
                    <h2 className="font-serif text-3xl text-ink-50 mt-2">L&apos;immobile è online.</h2>
                    <p className="text-ink-300 text-sm mt-3">
                        L&apos;annuncio è ora visibile su <span className="text-gold">vendidirect.it</span> e viene distribuito automaticamente ai portali esterni che hai attivato nella sezione <b>Portali</b>. Lo trovi nel tab <b>Immobili</b>.
                    </p>
                    <div className="flex flex-wrap gap-3 mt-6">
                        <button
                            data-testid="crm-new-property-goto-immobili"
                            onClick={() => onGoToProperties && onGoToProperties()}
                            className="cta-gold px-5 py-2.5 text-xs flex items-center gap-2"
                        >Vai a Immobili <ArrowRight size={12} /></button>
                        <a
                            data-testid="crm-new-property-view-public"
                            href={`/annunci/${publishedId}`}
                            target="_blank" rel="noreferrer"
                            className="cta-outline px-5 py-2.5 text-xs flex items-center gap-2"
                        >Apri annuncio pubblico</a>
                        <button
                            data-testid="crm-new-property-again"
                            onClick={() => setPublishedId(null)}
                            className="cta-outline px-5 py-2.5 text-xs"
                        >Pubblica un altro</button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div data-testid="crm-new-property" className="space-y-6">
            <div>
                <span className="label-eyebrow text-gold">VD Manager · Acquisizione</span>
                <h2 className="font-serif text-3xl text-ink-50 mt-2 flex items-center gap-2">
                    <PlusSquare size={22} className="text-gold" /> Nuovo Annuncio
                </h2>
                <p className="text-ink-400 text-sm mt-1 max-w-2xl">
                    Pubblica un nuovo immobile. Verrà visibile subito su <span className="text-gold">vendidirect.it</span>, apparirà nella tua sezione <b>Immobili</b> e sarà distribuito automaticamente ai portali esterni attivati.
                </p>
            </div>
            <PropertyForm mode="create" embedded={true} onSuccess={handleSuccess} />
        </div>
    );
}
